<template>
  <el-dialog
    append-to-body
    class="stack_view"
    title="垛标详情"
    :visible.sync="dialogVisible"
    width="15%"
  >
    <p>产品数量：{{ data.length }}</p>
    <p>垛标码：{{ stack_code }}</p>
    <el-table :data="data" border style="width: 100%">
      <el-table-column prop="big_code" label="物流码"> </el-table-column>
      <el-table-column prop="count" label="数量"> </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    logistics_code: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      stack_code: "",
      data: [],
    };
  },
  watch: {
    logistics_code: {
      handler() {
        this.updateData();
      },
      immediate: true,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    async updateData() {
      if (!this.logistics_code) return;
      await this.$nextTick();
      const loading = this.$loading({
        target: ".stack_view .el-dialog__body",
      });
      const res = await this.$get("logistics", "/stack.search", {
        big_code: this.logistics_code,
      });
      this.stack_code = res.data.stack_code;
      this.data = res.data.list;
      loading.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.stack_view {
  p {
    font-size: 16px;
    line-height: 1.5;
  }
  .el-table {
    margin-top: 5px;
  }
}
</style>
